export var KEY_A = 65;
export var KEY_RETURN = 13;
export var KEY_ESC = 27;
export var KEY_LEFT = 37;
export var KEY_UP = 38;
export var KEY_RIGHT = 39;
export var KEY_DOWN = 40;
export var KEY_BACKSPACE = 8;
export var KEY_DELETE = 46;
export var KEY_TAB = 9;
export var IS_MAC = typeof navigator === 'undefined' ? false : /Mac/.test(navigator.userAgent);
export var KEY_SHORTCUT = IS_MAC ? 'metaKey' : 'ctrlKey'; // ctrl key or apple key for ma